// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1bdHw","right":"styles_right__18voD"};